import {GridList} from 'shells/grid-list/grid-list';

import type {AiStatFragment} from 'nutshell-graphql-types';

import {LoadingCards} from './loading-cards';
import {StatCard} from './stat-card';

interface Props {
    stats: AiStatFragment[];
    numColumns: number;
    isLoading: boolean;
    isPrimary: boolean;
    isMonthView?: boolean;
}

export function StatsGrid(props: Props) {
    return (
        <GridList numColumns={props.numColumns}>
            {props.isLoading ? (
                <LoadingCards count={props.numColumns} isPrimary={props.isPrimary} />
            ) : (
                props.stats.map((stat, i) => (
                    <StatCard
                        key={stat.displayName ?? i}
                        stat={stat}
                        index={i}
                        isPrimary={props.isPrimary}
                        isMonthView={props.isMonthView}
                    />
                ))
            )}
        </GridList>
    );
}
